firebird.controller('presenterGreenroomFooterCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    'logService',
    'socketService',
    'growlService',
    'contentService',
    'connectivityService',
    'attendeeService',
    'meetingService',
    'analyticsWrapperService',
    'brandingService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        $window,
        logService,
        socketService,
        growlService,
        contentService,
        connectivityService,
        attendeeService,
        meetingService,
        analyticsWrapperService,
        brandingService,
        localizationService
    ) {
        var self = this;

        self.welcomeMsg = '';
        self.recordingEnabled = hasRecordingFeature();
        self.waitingForContentStopped = false;

        self.isConferenceConnected = isConferenceConnected;
        self.updateWelcomeMsg = updateWelcomeMsg;
        self.clearWelcomeMsg = clearWelcomeMsg;
        self.goOnAir = goOnAir;
        self.getOnAirBtnTooltip = getOnAirBtnTooltip;
        self.isOnAirBtnEnabled = isOnAirBtnEnabled;
        self.hasRecordingFeature = hasRecordingFeature;
        self.getRecordingOnAirTooltip = getRecordingOnAirTooltip;

        $scope.$on('content-stopped', onContentStopped);
        $scope.$on('waiting-room-msg-updated', onWaitingRoomMsgUpdated);

        init();

        ////////////////////////

        function init() {
            socketService.send({
                message: 'retrieve-waiting-room-msg',
                data: '',
                callback: function (newMsg) {
                    self.welcomeMsg = newMsg || '';
                    digest();
                }
            });
        }

        function hasRecordingFeature() {
            var featureList = meetingService.getFeatureList();
            if (featureList && featureList.recording === 'enabled') {
                return true;
            }
            return false;
        }

        function getRecordingOnAirTooltip() {
            if (!self.hasRecordingFeature()) {
                if (brandingService.isAnymeetingDirect()) {
                    return localizationService.translate('RECORD.TOOLTIP.YOUR_PLAN_DOERS_NOT_INCLUDE_THIS_FEATURE');
                } else {
                    return localizationService.translate(
                        'RECORD.TOOLTIP.YOUR_PLAN_DOERS_NOT_INCLUDE_THIS_FEATURE_CONTACT_ADMIN'
                    );
                }
            } else {
                return '';
            }
        }

        function isConferenceConnected() {
            return connectivityService.getConferenceConnected();
        }

        function updateWelcomeMsg(newMsg) {
            if (!newMsg) {
                logService.log('No welcome message provided... returning');
                return;
            }

            logService.log('Updating welcome message:', newMsg);

            socketService.send({
                message: 'update-waiting-room-msg',
                data: { message: newMsg }
            });
        }

        function clearWelcomeMsg() {
            if (self.welcomeMsg === '') {
                logService.log('Welcome message already cleared... returning');
                return;
            }

            logService.log('Clearing welcome message');

            socketService.send({
                message: 'update-waiting-room-msg',
                data: { message: '' }
            });

            //Clear textarea
            self.welcomeMsg = '';
        }

        function onWaitingRoomMsgUpdated(e, data) {
            if (data) {
                var newMsg = data.message || '';
                logService.log('Waiting Room Msg Updated:', newMsg || 'empty string');

                self.welcomeMsg = newMsg;
                digest();

                var growlMsg = localizationService.translate(
                    'PRESENTER_GREENROOM.AUDIENCE_WELCOME_MESSAGE_HAS_BEEN_UPDATED'
                );
                var firstName =
                    data.requester && data.requester.screenName ? data.requester.screenName.split(' ')[0] : '';
                var isSelf = data.requester && data.requester.attendantId === attendeeService.getAttendantId();

                if (firstName && !isSelf) {
                    growlMsg = localizationService.translate(
                        'PRESENTER_GREENROOM.AUDIENCE_WELCOME_MESSAGE_HAS_BEEN_UPDATED_BY_PERSON',
                        { person: firstName }
                    );
                }

                growlService.show(growlMsg, 'success');
            }
        }

        function goOnAir() {
            //If video playing, prompt user that content sharing
            //will be stopped before going on-air
            if (contentService.isContentPlaying() && contentService.getContentType() === 'video') {
                logService.log('Content playing... prompting user before going On-Air');

                var contentShareSwalParams = getSwalParams();
                contentShareSwalParams.title = localizationService.translate(
                    'PRESENTER_GREENROOM.CONTENT_PLAING.TITLE'
                );
                contentShareSwalParams.text = localizationService.translate('PRESENTER_GREENROOM.CONTENT_PLAING.TEXT');
                contentShareSwalParams.confirmButtonText = localizationService.translate(
                    'PRESENTER_GREENROOM.CONTENT_PLAING.CONFIRM'
                );
                contentShareSwalParams.cancelButtonText = localizationService.translate(
                    'PRESENTER_GREENROOM.CONTENT_PLAING.CANCEL'
                );

                $window.swal(contentShareSwalParams, function (stopFileshare) {
                    if (stopFileshare) {
                        logService.log('Stopping current content before going on-air');
                        self.waitingForContentStopped = true;
                        contentService.stopCurrentContent();
                    } else {
                        logService.log('User chose to keep sharing content in practice mode');
                    }
                });

                return;
            }

            logService.log('Prompting user before going On-Air...');

            var onAirWarningSwalParams = getSwalParams();
            onAirWarningSwalParams.title = localizationService.translate('PRESENTER_GREENROOM.BEFORE_ON_AIR.TITLE');
            onAirWarningSwalParams.text = localizationService.translate('PRESENTER_GREENROOM.BEFORE_ON_AIR.TEXT');
            onAirWarningSwalParams.confirmButtonText = localizationService.translate(
                'PRESENTER_GREENROOM.BEFORE_ON_AIR.CONFIRM'
            );
            onAirWarningSwalParams.cancelButtonText = localizationService.translate(
                'PRESENTER_GREENROOM.BEFORE_ON_AIR.CANCEL'
            );

            $window.swal(onAirWarningSwalParams, function (goOnAir) {
                if (goOnAir) {
                    logService.log('Going on air...', 'Recording Enabled:', self.recordingEnabled);

                    analyticsWrapperService.eventTrack('Meeting - Webinar - On-Air Attempt');

                    socketService.send({
                        message: 'go-on-air',
                        data: {
                            recordingEnabled: self.recordingEnabled
                        }
                    });
                } else {
                    logService.log('User cancelled On-Air prompt');
                }
            });
        }

        function onContentStopped(e, data) {
            if (self.waitingForContentStopped) {
                self.waitingForContentStopped = false;

                logService.log('Content stop event received... going on-air');
                self.goOnAir();
            }
        }

        function getOnAirBtnTooltip() {
            if (!attendeeService.getIsHost()) {
                return localizationService.translate('PRESENTER_GREENROOM.ONLY_OWNER_CAN_START');
            }

            if (!self.isConferenceConnected()) {
                return localizationService.translate('PRESENTER_GREENROOM.MUST_BE_CONNECTED');
            }

            return localizationService.translate('PRESENTER_GREENROOM.CLICK_TO_ON_AIR');
        }

        function isOnAirBtnEnabled() {
            if (!attendeeService.getIsHost()) {
                return false;
            }

            if (!self.isConferenceConnected()) {
                return false;
            }

            return true;
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        //Helper Function
        function getSwalParams() {
            return {
                title: '',
                text: '',
                showCancelButton: true,
                confirmButtonColor: brandingService.getBaseColor(),
                confirmButtonText: '',
                cancelButtonText: '',
                closeOnConfirm: true,
                type: 'warning',
                allowOutsideClick: true
            };
        }
    }
]);
